import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { fetchCompany } from 'services/companyService';
import { loadInstallmentReceipt } from 'store/reducers/commonsReducer';

// ==============================|| APP ||============================== //

const App = () => {
    const { customization, user } = useSelector((state) => state);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadInstallmentReceipt());
    }, [dispatch]);

    useEffect(() => {
        async function fetchData() {
            await dispatch(fetchCompany());
        }
        fetchData().catch((data) => console.error(data));
    }, [dispatch, user]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <NavigationScroll>
                    <Routes />
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
